import { useState } from 'react';
import { Star } from 'lucide-react';

export const EventRating = ({ rating, onChange, readonly = false, size = 'md' }) => {
  const [hovered, setHovered] = useState(0);
  
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8'
  };
  
  const starSize = sizeClasses[size] || sizeClasses.md;
  
  const handleClick = (starValue) => {
    if (readonly) return;
    // If clicking the same star, toggle it off
    onChange(rating === starValue ? 0 : starValue);
  };
  
  return (
    <div 
      className="flex items-center gap-1"
      onMouseLeave={() => setHovered(0)}
      data-testid="event-rating"
    >
      {[1, 2, 3, 4, 5].map((star) => {
        const isFilled = star <= (hovered || rating);
        return (
          <button
            key={star}
            type="button"
            onClick={() => handleClick(star)}
            onMouseEnter={() => !readonly && setHovered(star)}
            disabled={readonly}
            className={`transition-colors ${readonly ? 'cursor-default' : 'cursor-pointer hover:scale-110'}`}
            data-testid={`star-${star}`}
          >
            <Star
              className={`${starSize} transition-colors ${
                isFilled 
                  ? 'text-yellow-500 fill-yellow-500' 
                  : 'text-gray-300 hover:text-yellow-300'
              }`}
            />
          </button>
        );
      })}
      {rating > 0 && (
        <span className="ml-2 text-sm text-gray-500">
          {rating}/5
        </span>
      )}
    </div>
  );
};

export default EventRating;
